(ns common.fields.filter-types
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [common.schema.data-types :as data-types]
   [common.time :as ct]))

(defonce multi-operands [:operand/none-of :operand/all-of :operand/any-of])

(defonce operands-by-operand-type
  {:text    [:operand/contains
             :operand/contains-exactly
             :operand/does-not-contain-exactly
             :operand/known
             :operand/unknown]
   :numeric [:operand/equals
             :operand/not-equal
             :operand/greater-than
             :operand/equal-or-greater-than
             :operand/smaller-than
             :operand/equal-or-smaller-than
             :operand/between-exclusive
             :operand/known
             :operand/unknown]
   :date    [:operand/between-inclusive-date
             :operand/on-or-before
             :operand/on-or-after
             :operand/equals-date
             :operand/known
             :operand/unknown]
   :on-off  [:operand/true
             :operand/false
             :operand/unknown
             :operand/known]
   :known   [:operand/unknown
             :operand/known]
   :option  [:operand/any-of
             :operand/all-of
             :operand/none-of
             :operand/known
             :operand/unknown]})

(defonce operand-types-by-filter-type
  {:filter.type/text       :text
   :filter.type/boolean    :on-off
   :filter.type/date       :date
   :filter.type/select     :option
   :filter.type/number     :numeric
   :filter.type/integer    :numeric
   :filter.type/percentage :numeric
   :filter.type/multiplier :numeric
   :filter.type/known      :known
   :filter.type/none       nil})


(defonce operands-by-filter-type
  {:filter.type/text       (get operands-by-operand-type :text)
   :filter.type/boolean    (get operands-by-operand-type :on-off)
   :filter.type/date       (get operands-by-operand-type :date)
   :filter.type/select     (get operands-by-operand-type :option)
   :filter.type/number     (get operands-by-operand-type :numeric)
   :filter.type/integer    (get operands-by-operand-type :numeric)
   :filter.type/percentage (get operands-by-operand-type :numeric)
   :filter.type/multiplier (get operands-by-operand-type :numeric)
   :filter.type/known      (get operands-by-operand-type :known)
   :filter.type/none       []})

(defonce editor-by-filter-type
  {:filter.type/text       :editor.type/text-simple
   :filter.type/boolean    :editor.type/select
   :filter.type/date       :editor.type/date
   :filter.type/select     :editor.type/select
   :filter.type/number     :editor.type/number
   :filter.type/integer    :editor.type/integer
   :filter.type/percentage :editor.type/percentage
   :filter.type/multiplier :editor.type/multiplier
   :filter.type/file       :editor.type/none
   :filter.type/none       :editor.type/none})


(defn operand-editor
  [editor-type operand]
  (if
   (and (= editor-type :editor.type/select)
        (some #{operand} [:operand/any-of :operand/all-of :operand/none-of]))
    :editor.type/multi-select
    editor-type))

(defn bound-label
  [operand upper-bound?]
  (case operand
    :operand/between-inclusive (loc/tr (if upper-bound? :operand-value/less-than-or-equal :operand-value/greater-than-or-equal))
    :operand/between-exclusive (loc/tr (if upper-bound? :operand-value/less-than :operand-value/greater-than))
    :operand/between-inclusive-date (loc/tr (if upper-bound? :operand-value/before-or-on :operand-value/after-or-on))
    :operand/between-exclusive-date (loc/tr (if upper-bound? :operand-value/before :operand-value/after))
    (loc/tr operand)))

(defn smaller-than
  ([value lower-bound]
   (smaller-than value lower-bound false))
  ([value lower-bound matching?]
   (let [res
         (if matching?
           (<= value lower-bound)
           (< value lower-bound))]
     res)))

(defn numeric-filter
  [operand value lower-bound upper-bound & [logger]]
  (if (nil? value)
    (case operand
      :operand/unknown true
      :operand/not-equal true
      false)
    (case operand
      :operand/equals (= value lower-bound)
      :operand/not-equal (not= value lower-bound)
      :operand/smaller-than (smaller-than value lower-bound)
      :operand/greater-than (smaller-than lower-bound value)
      :operand/equal-or-smaller-than (smaller-than value lower-bound true)
      :operand/equal-or-greater-than (smaller-than lower-bound value true)
      :operand/between-exclusive (and (smaller-than value upper-bound)
                                      (smaller-than lower-bound value))
      :operand/between-inclusive (and (smaller-than value upper-bound true)
                                      (smaller-than lower-bound value true))
      :operand/known true
      false)))

(defn date-filter
  [operand value lower-bound upper-bound & [logger]]
  (if (empty? value)
    (if (= operand :operand/unknown)
      true
      false)
    (case operand
      :operand/equals-date (if (and (string? lower-bound) (string? value))
                             (= value lower-bound)
                             (let [value-ts (cond (number? value) value
                                                  (string? value) (do
                                                                    (when logger
                                                                      (logger "PARSE DATE : " value))
                                                                    (ct/date-str->millis value)))
                                   lower-bound-ts (cond (number? lower-bound) lower-bound
                                                        (string? lower-bound) (ct/date->millis lower-bound))]
                               (and (<= lower-bound-ts value-ts)
                                    (< value-ts (+ lower-bound-ts (* 1000 3600 24))))))
      :operand/after (smaller-than lower-bound value)
      :operand/on-or-after (smaller-than lower-bound value true)
      :operand/on-or-before (smaller-than value lower-bound true)
      :operand/before (smaller-than value lower-bound)
      :operand/between-inclusive-date (and (smaller-than value upper-bound true)
                                           (smaller-than lower-bound value true))
      :operand/between-exclusive-date (and (smaller-than value upper-bound)
                                           (smaller-than lower-bound value))
      :operand/known true                                                                           ;;not empty
      false)))

(defn onn-off-filter
  [operand value lower-bound upper-bound]
  (case operand
    :operand/true (true? value)
    :operand/false (or (false? value)
                       (nil? value))
    false))

(defn option-filter
  [operand value lower-bound upper-bound & [logger]]
  (let [filter-value-set (set lower-bound)
        value-set (if (or (nil? value) (coll? value))
                    (set value)
                    #{value})
        res (boolean (condp = operand
                       :operand/any-of (some value-set filter-value-set)
                       :operand/all-of (every? value-set filter-value-set)
                       :operand/none-of (not (some value-set filter-value-set))
                       :operand/known (not (empty? value-set))
                       :operand/unknown (empty? value-set)
                       (when logger
                         (logger "FILTER OPTION : " lower-bound " contains " value " -> " operand))))]
    res))

(defn text-filter
  [operand value lower-value upper-value]
  (if (empty? value)
    (case operand
      :operand/does-not-contain-exactly true
      :operand/unknown true
      false)
    (let [str-v (some->> value
                         (str)
                         (string/lower-case)
                         (string/trim))
          str-l (some->> lower-value
                         (str)
                         (string/lower-case)
                         (string/trim))
          str-u (some->> upper-value
                         (str)
                         (string/lower-case)
                         (string/trim))]
      (case operand
        :operand/contains-exactly (string/includes? (string/trim (str value)) lower-value)
        :operand/does-not-contain-exactly (not (string/includes? (string/trim (str value)) lower-value))
        :operand/starts-with-display-string (string/starts-with? str-v str-l)
        :operand/ends-with-display-string (string/ends-with? str-v str-l)
        :operand/equals-display-string (= str-v str-l)
        :operand/contains-display-string (string/includes? str-v str-l)
        :operand/contains (string/includes? str-v str-l)
        :operand/known true
        false))))

(defn filter-value
  [type operand value lower-bound upper-bound & [logger]]
  (let [operand-type (operand-types-by-filter-type type)]
    (cond
      (= :text operand-type) (text-filter operand value lower-bound upper-bound)
      (= :numeric operand-type) (numeric-filter operand value lower-bound upper-bound logger)
      (= :date operand-type) (date-filter operand value lower-bound upper-bound logger)
      (= :on-off operand-type) (onn-off-filter operand value lower-bound upper-bound)
      (= :option operand-type) (option-filter operand value lower-bound upper-bound logger)
      :default (do
                 (when logger
                   (logger "Could not resolve operand-type " operand-type " << " type))
                 true))))

(defn data-type->filter-operators
  [data-type]
  (->> (get data-types/zapflow-data-types data-type)
       :default-filter
       (get operands-by-filter-type)
       ))
